import { createContext, useContext } from 'react';
import { Experiments } from 'types/Experiments';

export const ExperimentsContext = createContext<Experiments>({});

export const useExperimentsContext = () => useContext(ExperimentsContext);
